<template>
  <div class="top-image-container">
    <div class="top-image-wrapper">
      <img class="top-image-image" :src="product.image" alt="">
    </div>
    <div style="margin-top: 0.5em;">
      <p>{{ `${product.seller.name} (${product.seller.id})` }}</p>
      <a class="product-url-link" :href="product.url" target="_blank">{{ product.name }}</a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    toogleMatch() {
      this.$emit('matchFromTop')
    }
  }
}
</script>
<style scoped>
.match {
  background-color: #00948F;
}
.top-image-container {
  max-width: 100%;
  overflow: hidden;
  color: #fff;
  margin: 1em;
}
.top-image-wrapper {
  /* height: 25em; */
  width: 100%;
  overflow: hidden;
}
.top-image-image {
  width: inherit;
  transition: 0.2s;
}
.top-image-image:hover {
  transform: scale(1.2);
}
</style>  